<app-uni-dialog [parent]="this" [contentTemplate]="contentTemplate" [footerTemplate]="footerTemplate"></app-uni-dialog>

<ng-template #contentTemplate>
  <div class="flex flex-row gap-3 mt-3">
    <uni-field label="Account Name" class="w-7/12">
      <input [ngModel]="account.accountName" name="accountName" disabled pInputText />
    </uni-field>
    <uni-field label="Start Date" class="w-5/12">
      <p-datepicker [disabled]="true" [(ngModel)]="account.startDate" />
    </uni-field>
  </div>

  <div class="flex flex-row gap-3 mt-3">
    <uni-field label="Doc Submit Type" class="w-1/4">
      <p-dropdown
        [options]="docSubmitTypes"
        [(ngModel)]="account.invoiceDocSubmitTypeId"
        optionValue="id"
        optionLabel="name"
        [disabled]="true"
      />
    </uni-field>
    <uni-field label="Invoice and Manifest Email" class="w-3/4">
      <input type="email" [(ngModel)]="account.invoiceEmail" disabled pInputText />
    </uni-field>
  </div>

  <div class="flex flex-row gap-3 mt-3">
    <uni-field label="Due Date # Days" class="w-1/4">
      <input type="number" [(ngModel)]="account.dueDateNumDays" name="dueDateNumDays" disabled pInputText />
    </uni-field>
    <uni-field>
      <p-checkbox
        [disabled]="true"
        [(ngModel)]="account.allowReissuanceOrders"
        [binary]="true"
        [ngModelOptions]="{ standalone: true }"
        inputId="allowReissuanceOrders"
      />
      <label for="allowReissuanceOrders" class="ml-2">Account-Owned Inventory Management</label>
    </uni-field>

    <uni-field>
      <p-checkbox
        [disabled]="true"
        [(ngModel)]="account.allowPartialShipments"
        [binary]="true"
        [ngModelOptions]="{ standalone: true }"
        inputId="allowPartialShipments"
      />
      <label for="allowPartialShipments" class="ml-2">Allow Partial Shipments</label>
    </uni-field>

    <uni-field>
      <p-checkbox
        [disabled]="true"
        [(ngModel)]="account.saveOutputToPdf"
        [binary]="true"
        [ngModelOptions]="{ standalone: true }"
        inputId="saveOutputToPdf"
      />
      <label for="saveOutputToPdf" class="ml-2">Save Output to PDF</label>
    </uni-field>
  </div>

  <div class="flex flex-row gap-3 mt-3">
    <uni-field>
      <p-checkbox
        [(ngModel)]="account.isPickupAccount"
        [binary]="true"
        [ngModelOptions]="{ standalone: true }"
        inputId="isPickupAccount"
      />
      <label for="isPickupAccount" class="ml-2">Customer Picks Up Orders</label>
      <div class="text-sm mt-1" style="color: var(--p-text-muted-color)">
        Orders for this account are collected at the counter. On Shipping and Invoice, Release for Pickup
        skips the freight quote and shipping label. Individual orders can still be shipped by carrier.
      </div>
    </uni-field>
  </div>

  <div class="flex flex-row gap-3 mt-3">
    <uni-field>
      <p-checkbox
        [(ngModel)]="account.excludeFromAnalytics"
        [binary]="true"
        [ngModelOptions]="{ standalone: true }"
        inputId="excludeFromAnalytics"
      />
      <label for="excludeFromAnalytics" class="ml-2">Exclude from Dashboard Analytics</label>
      <div class="text-sm mt-1" style="color: var(--p-text-muted-color)">
        The dashboard does not count this account. Revenue is the exception: the amount invoiced
        always includes this account. If you select this account in the Account Filter, the
        dashboard shows its data.
      </div>
    </uni-field>
  </div>

  <div class="flex flex-row gap-3 mt-3">
    <uni-field label="Tax Exemption #" class="w-1/2">
      <input [ngModel]="account.accountTaxExemptionNumber" disabled pInputText />
    </uni-field>
    <uni-field label="GL Account Ref" class="w-1/2">
      <div class="flex items-center gap-2">
        <input [ngModel]="account.gLAccountRef" disabled pInputText class="flex-1" title="GL Account Ref" />
        <a *ngIf="!account.gLAccountRef" href="javascript:void(0)" (click)="openQboCustomerLinkDialog()"
           class="bluelink text-sm whitespace-nowrap">
          Set up in QBO...
        </a>
      </div>
    </uni-field>
  </div>

  <div class="flex flex-row gap-3 mt-3">
    <uni-field label="Id" class="w-1/2">
      <input [ngModel]="account.id" disabled pInputText title="Id" />
    </uni-field>
    <uni-field label="Proximity Id" class="w-1/2">
      <input [ngModel]="account.proximityAccountId" disabled pInputText title="Proximity Id" />
    </uni-field>
  </div>
</ng-template>

<ng-template #footerTemplate>
  <div class="flex flex-row gap-2">
    <button
      [disabled]="!this.uow.hasChanges()"
      (click)="ok()"
      pButton
      type="button"
      class="p-button-raised"
    >
      Ok
    </button>
    <button (click)="cancel()" pButton type="button" class="p-button-raised">Cancel</button>
  </div>
</ng-template>
